'use strict';

var _ = require('lodash');
var SaveAndInitializeModalController = function SaveAndInitializeModalController($scope, momentService, configurationService, featureToggleService, SeasonalityConstants) {
  var OFFLINE = 'Offline';
  var DEFAULT_DATE_FROM = 366;
  var DEFAULT_DATE_TO = 1;
  $scope.includeDOWGroup = false;
  $scope.clearDemandAdjsFlag = false;
  $scope.DATE_SETTINGS = {
    showTodayButton: false
  };
  $scope.maxDateTo = momentService.now(momentService.FIELD.DEPARTURE_DATE).subtract(1, 'day');
  $scope.calendarRange = {
    dateRangeFrom: undefined,
    dateRangeTo: undefined
  };
  $scope.getForecastTypeForInit = function (displayedCalendar) {
    var market = displayedCalendar.market.split('-');
    var marketData = _.find(configurationService.getMarkets(), {
      origin: market[0],
      destination: market[1]
    });
    return {
      value: _.get(marketData, 'forecastType', 'Market')
    };
  };
  $scope.forecastTypeForInit = $scope.getForecastTypeForInit($scope.displayedCalendar);
  $scope.forecastTypeList = SeasonalityConstants.FORECAST_TYPES;
  $scope.isDirectForecastDemandCalendar = featureToggleService.isEnabled('DIRECT_FORECAST_ENABLE') && $scope.screenState.calendarModeLabel === 'Demand';
  $scope.isSubmitBtnEnabled = function () {
    return $scope.calendarRange.dateRangeFrom && $scope.calendarRange.dateRangeTo;
  };
  $scope.updateDateRange = function () {
    if ($scope.displayedCalendar.seasonalityVariable === OFFLINE) {
      $scope.calendarRange.dateRangeFrom = momentService.now(momentService.FIELD.DEPARTURE_DATE).subtract(DEFAULT_DATE_FROM, 'day');
      $scope.calendarRange.dateRangeTo = momentService.now(momentService.FIELD.DEPARTURE_DATE).subtract(DEFAULT_DATE_TO, 'day');
    } else {
      $scope.calendarRange.dateRangeFrom = $scope.displayedCalendar.startDepartureDate;
      $scope.calendarRange.dateRangeTo = $scope.displayedCalendar.endDepartureDate;
    }
  };
  $scope.$watchGroup(['displayedCalendar.seasonalityVariable', 'displayedCalendar.startDepartureDate', 'displayedCalendar.endDepartureDate'], $scope.updateDateRange);
  $scope.submit = function () {
    var market = $scope.displayedCalendar.market.split('-');
    var payload = [{
      origin: market[0],
      destination: market[1],
      startDepartureDate: $scope.calendarRange.dateRangeFrom,
      endDepartureDate: $scope.calendarRange.dateRangeTo,
      calendarName: $scope.displayedCalendar.calendarName,
      dowGroupFlag: $scope.includeDOWGroup,
      clearDemandAdjsFlag: $scope.clearDemandAdjsFlag
    }];
    if ($scope.isDirectForecastDemandCalendar) {
      payload[0].forecastType = $scope.forecastTypeForInit.value;
    }
    $scope.$emit('seasonality-analysis:save-and-initialize', payload);
  };
};
SaveAndInitializeModalController.$inject = ['$scope', 'MomentService', 'ConfigurationService', 'FeatureToggleService', 'SeasonalityConstants'];
module.exports = SaveAndInitializeModalController;